import { push }              from "connected-react-router";
import { useDispatch }       from "react-redux";
import { Dispatch }          from "redux";
import GetCustomers          from "../../../application/usecase/customer/GetCustomers";
import GetPublishNotice      from "../../../application/usecase/notice/GetPublishNotice";
import CustomerSearchValue   from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType      from "../../../domain/customer/criteria/CustomerSortType";
import CurrentPage           from "../../../domain/fundamentals/pagination/CurrentPage";
import MailSend              from "../../../domain/mail/send/MailSend";
import MailSendRepository    from "../../../domain/mail/send/MailSendRepository";
import Reservation           from "../../../domain/reservation/Reservation";
import ReservationRepository from "../../../domain/reservation/ReservationRepository";
import MailSendDataSource    from "../../datasource/mail/send/MailSendDataSource";
import ReservationDataSource from "../../datasource/reservation/ReservationDataSource";

class RouterDispatcher {
  private readonly getPublishNotice: GetPublishNotice = new GetPublishNotice(this.dispatch);
  private readonly getCustomers: GetCustomers = new GetCustomers(this.dispatch);
  private readonly mailSendRepository: MailSendRepository = new MailSendDataSource(this.dispatch);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  private readonly reservationRepository: ReservationRepository = new ReservationDataSource(useDispatch());

  constructor(private readonly dispatch: Dispatch) {
  }

  public login() {
    this.dispatch(push("/"));
  }

  public logout() {
    this.dispatch(push("/logout"));
  }

  public notice() {
    this.getPublishNotice.execute();
    this.dispatch(push("/notice"));
  }

  public setting() {
    this.dispatch(push("/setting"));
  }

  public reservationSetting() {
    this.dispatch(push("/reservation/setting"));
  }

  public office() {
    this.dispatch(push("/office"));
  }

  public corporation() {
    this.dispatch(push("/corporation"));
  }

  public staffs() {
    this.dispatch((push("/staffs")));
  }

  public staffRegister() {
    this.dispatch((push("/staff/register")));
  }

  public staffEdit() {
    this.dispatch((push("/staff/edit")));
  }

  public recordTemplates() {
    this.dispatch(push("/record/templates"));
  }

  public recordTemplateRegister() {
    this.dispatch(push("/record/template/register"));
  }

  public recordTemplateEdit() {
    this.dispatch(push("/record/template/edit"));
  }

  public customers() {
    this.getCustomers.execute(new CurrentPage(), new CustomerSearchValue(), CustomerSortType.NONE);
    this.dispatch(push("/customers"));
  }

  public customerRegister() {
    this.dispatch(push("/customer/register"));
  }

  public customerEdit() {
    this.dispatch(push("/customer/edit"));
  }

  public customerRecords() {
    this.dispatch(push("/customer/records"));
  }

  public customerRecordRegister() {
    this.dispatch(push("/customer/record/register"));
  }

  public customerRecordEdit() {
    this.dispatch(push("/customer/record/edit"));
  }

  public customerImport() {
    this.dispatch(push("/customer/import"));
  }

  public mailSetting() {
    this.dispatch(push("/mail/setting"));
  }

  public mailSend() {
    this.mailSendRepository.setMailSend(new MailSend());
    this.dispatch(push("/mail"));
  }

  public reservation() {
    this.reservationRepository.setReservation(new Reservation());
    this.dispatch(push("/reservation"));
  }

  public paymentRegister() {
    window.location.href = "/payment/register";
  }

  public paymentComplete() {
    this.dispatch(push("/payment/complete"));
  }

  public plans() {
    this.dispatch(push("/plans"));
  }
}

export default RouterDispatcher;
